import * as React from 'react';
import {RouteComponentProps} from 'react-router';
import {
  BarChart, Bar, XAxis, YAxis, ResponsiveContainer, LabelList
} from 'recharts';

import HollandClient from '../../api/HollandClient';
import Header from "../../components/Header/Header";

export interface State{
  dataResults: any[]
}

import styles from './HollandProfilePage.module.scss';
class HollandProfilePage extends React.Component<{} & RouteComponentProps<any>, State>{
  public state = {
    dataResults: [
      { name: 'Artístico', value: 0 },
      { name: 'Assessoria', value: 0 },
      { name: 'Empreendedor', value: 0 },
      { name: 'Pesquisador', value: 0 },
      { name: 'Realístico', value: 0 },
      { name: 'Social', value: 0 },
    ]
  };

  public render(){
    return (
      <div className={styles.hollandProfilePage}>
        <Header page={'Perfil Holland'} reloadable={false}/>
        <ResponsiveContainer>
          <BarChart
            width={400}
            height={300}
            data={this.state.dataResults}
            layout="vertical"
          >
            <YAxis dataKey="name" type={'category'} hide={true}/>
            <XAxis type="number"/>

            <Bar dataKey="value" fill="#82ca9d">
              <LabelList dataKey="name" position="insideLeft" />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    )
  }

  public async componentDidMount(){
    const response = await HollandClient().getProfile(this.props.match.params.id);

    const { artistico, assessoria, empreendedor, pesquisador, realistico, social} = response.result;

    const dataResults = [
      { name: 'Artístico', value: artistico },
      { name: 'Assessoria', value: assessoria },
      { name: 'Empreendedor', value: empreendedor },
      { name: 'Pesquisador', value: pesquisador },
      { name: 'Realístico', value: realistico },
      { name: 'Social', value: social },
    ];

    this.setState({
      dataResults
    });
  }

}

export default HollandProfilePage;
